import { checkDefined } from 'faro-common-model';
export function toAnalyticsConfig(config) {
    var _a;
    const enabled = (_a = config === null || config === void 0 ? void 0 : config.enabled) !== null && _a !== void 0 ? _a : false;
    if (enabled) {
        checkDefined(config.amplitudeapikey, 'AnalyticsConfig', 'amplitudeapikey');
    }
    return {
        enabled,
        amplitudeapikey: config.amplitudeapikey,
    };
}
//# sourceMappingURL=analytics-config.js.map